export default __webpack_public_path__ + "static/media/NIAS0120.34I-32850_-17921_0.036e5590.jpg";